/* eslint-disable no-undef */
class YoutubeVideoPlayer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.mobileOverlay = null
    this.desktopOverlay = null
    this.contentOverlay = null

    this.cacheOverlayElements()
    this.createYouTubeScriptTag()
  }

  cacheOverlayElements () {
    this.mobileOverlay = this.externalEls?.mobileOverlay?.element || null
    this.desktopOverlay = this.externalEls?.desktopOverlay?.element || null
    this.contentOverlay = this.externalEls?.contentOverlay?.element || null
  }

  createYouTubeScriptTag () {
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  onYouTubeIframeAPIReady () {
    this.player = new YT.Player('ytplayer', {
      height: '390',
      width: '640',
      videoId: this.els.player.element.dataset.youtubeVideoPlayerUrl,
      playerVars: {
        playsinline: 1,
      },
      events: {
        onReady: this.onPlayerReady.bind(this),
        onStateChange: this.onPlayerStateChange.bind(this),
      },
    })
  }

  onPlayerReady (event) {
    if (this.contentOverlay) {
      this.contentOverlay.style.opacity = '1'
      this.contentOverlay.style.pointerEvents = 'auto'
      this.contentOverlay.addEventListener('click', () =>
        this.handleOverlayClick(this.contentOverlay),
      )
    } else {
      if (this.mobileOverlay) {
        this.mobileOverlay.addEventListener('click', () =>
          this.handleOverlayClick(this.mobileOverlay),
        )
      }
      if (this.desktopOverlay) {
        this.desktopOverlay.addEventListener('click', () =>
          this.handleOverlayClick(this.desktopOverlay),
        )
      }
    }

    this.updateOverlayVisibility()
  }

  handleOverlayClick () {
    // Pause if the video is playing.
    if (this.contentOverlay && this.player.getPlayerState() === 1) {
      this.player.pauseVideo()
      this.contentOverlay.style.opacity = '1'
      this.contentOverlay.style.pointerEvents = 'auto'
      if (this.mobileOverlay) this.mobileOverlay.style.display = 'block'
      if (this.desktopOverlay) this.desktopOverlay.style.display = 'block'
    } else {
      this.player.playVideo()
      if (this.contentOverlay) {
        if (this.mobileOverlay) this.mobileOverlay.style.display = 'none'
        if (this.desktopOverlay) this.desktopOverlay.style.display = 'none'

        if (this.contentOverlay.dataset.hideContentOnClick === 'false') {
          return
        }

        this.contentOverlay.style.opacity = '0'
        this.contentOverlay.style.pointerEvents = 'none'
      }
    }
  }

  updateOverlayVisibility () {
    if (window.innerWidth <= 768) {
      if (this.mobileOverlay) this.mobileOverlay.style.display = 'block'
      if (this.desktopOverlay) this.desktopOverlay.style.display = 'none'
    } else {
      if (this.mobileOverlay) this.mobileOverlay.style.display = 'none'
      if (this.desktopOverlay) this.desktopOverlay.style.display = 'block'
    }
  }

  onPlayerStateChange (event) {
    if (
      event.data === YT.PlayerState.PAUSED ||
      event.data === YT.PlayerState.ENDED
    ) {
      if (this.contentOverlay) {
        this.contentOverlay.style.opacity = '1'
        this.contentOverlay.style.pointerEvents = 'auto'
      }
      this.updateOverlayVisibility()
    } else if (event.data === YT.PlayerState.PLAYING) {
      if (this.mobileOverlay) this.mobileOverlay.style.display = 'none'
      if (this.desktopOverlay) this.desktopOverlay.style.display = 'none'
    }
  }
}

// Make sure `onYouTubeIframeAPIReady` is globally available
window.onYouTubeIframeAPIReady = function () {
  const ytPlayerInstance = document.querySelector('youtube-video-player')
  if (ytPlayerInstance) {
    ytPlayerInstance.onYouTubeIframeAPIReady()
  }
}

if (!customElements.get('youtube-video-player')) {
  customElements.define('youtube-video-player', YoutubeVideoPlayer)
}
